export default "/assets/images/smoky-gray.54d46f2190685650.webp";